import type { SelectOption } from '@presentation/components';
import type { InputProps } from '@presentation/components/Input/types';

export interface InputSelectData<TValue> {
  search?: string;
  selectOptions?: SelectOption<TValue>[];
  onSearchChange?: (value?: string) => void;
  onSelect?: (selected: SelectOption<TValue> | undefined) => void;
  value?: TValue;
  loading?: boolean;
  useSearch?: boolean;
}

export interface InputSelectProps<TValue>
  extends Omit<InputProps, 'onSelect' | 'value'>,
    InputSelectData<TValue> {}
